import Api from '../Api';

export const getAccessories = () => async dispatch => {
  const { data } = await Api.get('/accessories');
  dispatch({
    type: 'FETCH_ACCESSORIES',
    payload: data,
  });
};

export const clearAccessories = () => {
  return {
    type: 'CLEAR_ACCESSORIES',
  };
};

export const getAccessory = id => async dispatch => {
  const { data } = await Api.get(`/accessories/${id}`);
  dispatch({
    type: 'FETCH_ACCESSORY',
    payload: data,
  });
};

export const clearAccessory = () => {
  return {
    type: 'CLEAR_ACCESSORY',
  };
};
